export default "__VITE_ASSET__M_R8LdnU__"